var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":"Funding amounts by type and stage","units":"Median and mean funding amount, million USD"}},[_c('Chart',{attrs:{"options":{
        ..._vm.chartOptions,
        series: _vm.fundingTypeSeries,
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }